import React, { useEffect, useState } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { DashboardLayout } from '../../../Layout/DashboardLayout'
import BASEURL from '../../../Config/global'
import axios from 'axios'
import CustomLoader from '../../../Components/CustomLoader'
import '../../FeaturedMix/style.css'
import BackButton from '../../../Components/BackButton'

const ViewScofaFeaturedMix = () => {
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const languageFromQuery = searchParams.get('language') || "english"

    const [formData, setFormData] = useState({})
    const [initialLoader, setInitialLoader] = useState(true)

    useEffect(() => {
        if (id) {
            getMixConfigurationById(id)
        }
    }, [id])

    const getMixConfigurationById = async (mixerId) => {
        try {
            setInitialLoader(true)
            const response = await axios.get(`${BASEURL}/api/sounds/set-mixer-category/?mixer_id=${mixerId}`)
            if (!response.data.error) {
                setFormData(response?.data?.data)
                setInitialLoader(false)
            }
        } catch (error) {
            console.error(error)
            setInitialLoader(false)
        }
    }

    if (initialLoader) {
        return (
            <DashboardLayout>
                <div className='container-fluid'>
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <CustomLoader />
                    </div>
                </div>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout>
            <div className='container-fluid'>

                <div className="row mb-3">
                    <div className="col-12">
                        <h2 className="mainTitle"> <BackButton />Scofa Highlight Mix Details</h2>
                    </div>
                </div>

                <div className="row w-100">
                    <div className='col-12'>
                        <div className='row mb-3'>
                            <div className='col-4'>
                                <p className="mainLabel">Title:</p>
                                <p>{formData?.title || "N/A"}</p>
                            </div>
                            <div className='col-4'>
                                <p className="mainLabel">Category:</p>
                                <p>{formData?.parent_category_name || "N/A"}</p>
                            </div>
                            <div className='col-4'>
                                <p className="mainLabel">Sub Category:</p>
                                <p>{formData?.sub_category_name || "N/A"}</p>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-4'>
                                <p className="mainLabel">Mix ID:</p>
                                <p>{formData?.id || "N/A"}</p>
                            </div>
                            <div className='col-4'>
                                <p className="mainLabel">Published:</p>
                                <p>{formData?.featured_mix_status ? "Yes" : "No"}</p>
                            </div>
                            <div className='col-4'>
                                <p className="mainLabel">Underage Restriction:</p>
                                <p>{formData?.child_content ? "Yes" : "No"}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-4 mt-3">
                        <p className="mainLabel">Banner Image:</p>
                        <div className="imageInput" style={{ height: '260px' }}>
                            {formData?.banner ? (
                                <img src={formData.banner} alt="Banner" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            ) : (
                                <p>No image available</p>
                            )}
                        </div>
                    </div>
                    <div className='col-8 mt-3'>
                        <p className="mainLabel">Description:</p>
                        <div className="mainInput" style={{ minHeight: '260px', padding: '15px', backgroundColor: '#ffffff1f', borderRadius: '10px' }}>
                            {formData?.description || "No description provided."}
                        </div>
                    </div>
                </div>

                <div className="pt-5 d-flex gap-3 justify-content-center mb-3">
                    <Link
                        to={`/scofa/featured-mix/edit/${formData.id}?language=${languageFromQuery}`}
                        className="customButton primaryButton px-5"
                    >
                        Edit
                    </Link>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default ViewScofaFeaturedMix
